import { render, staticRenderFns } from "./BrandBadge.vue?vue&type=template&id=ae883c74&"
import script from "./BrandBadge.vue?vue&type=script&lang=js&"
export * from "./BrandBadge.vue?vue&type=script&lang=js&"
import style0 from "./BrandBadge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports